import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { getPpisByItemCode } from '../../../../features/PpiContainer/selectors';
import usePreviewPpi from '../../../../features/PpiContainer/hooks/usePreviewPpi';
import { getLanguage } from '../../../../features/app/selectors';
import PpiList from '../../../PpiList/PpiList';
import GlobalPpiSection from './Global/GlobalPpiSection';
import LocalPpiSection from './Local/LocalPpiSection';

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(2)
  }
}));

const IngredientPpiSection = ({
  itemCode,
  isExcluded,
  ingredientOwningOrganization,
  selectedPpiDataId,
  onChangeSelectedPpi,
  globalIngredientId
}) => {
  const classes = useStyles();
  const language = useSelector(getLanguage);
  const ppis = useSelector(getPpisByItemCode(itemCode)).toJS();
  const [previewPPI, openPreview] = usePreviewPpi();
  const hasPpis = ppis.length > 0;

  // Scenarios
  // ---------------------------------
  // (1) PPI(s) matching current user's market exists
  //        --> Show it / them
  // (2) User is global
  //        --> No instructions exists, "Create Instruction" button
  // (3) User is local
  //        (a) Ingredient has organization IFS, and it has PPI(s) owned by IFS
  //            --> List PPI(s) along with copy and show "Create Instruction" (from scratch) button
  //        (b) User is in use case "Create from existing PPSI"
  //            --> No instructions exists, "Create Instruction" and "Copy Instruction" buttons
  //        (c) Otherwise
  //            --> No instructions exists, "Create Instruction" button.

  return (
    <>
      {previewPPI}
      <div className={classes.root}>
        {/* Scenario (1) */}
        {hasPpis && (
          <PpiList
            ppis={ppis}
            isExcluded={isExcluded}
            selectedPpiDataId={selectedPpiDataId}
            onChangeSelectedPpi={onChangeSelectedPpi}
            openPreview={openPreview}
            language={language}
          />
        )}
        {!hasPpis && (
          <>
            {/* Scenario (2) */}
            <GlobalPpiSection
              globalIngredientId={globalIngredientId}
              isExcluded={isExcluded}
              onChangeSelectedPpi={onChangeSelectedPpi}
              itemCode={itemCode}
            />
            {/* Scenario (3) */}
            <LocalPpiSection
              itemCode={itemCode}
              globalIngredientId={globalIngredientId}
              onChangeSelectedPpi={onChangeSelectedPpi}
              openPreview={openPreview}
              isExcluded={isExcluded}
              ingredientOwningOrganization={ingredientOwningOrganization}
            />
          </>
        )}
      </div>
    </>
  );
};

IngredientPpiSection.propTypes = {
  ingredientOwningOrganization: PropTypes.string,
  itemCode: PropTypes.string.isRequired,
  globalIngredientId: PropTypes.string.isRequired,
  selectedPpiDataId: PropTypes.string,
  onChangeSelectedPpi: PropTypes.func.isRequired
};

export default IngredientPpiSection;
